export default class AlerteSMS {
    id_module;
    propose = false;
    selected = false;
    prix = 5;

    constructor(id_module) {
        this.id_module = id_module;

    }
    set(data) {
        if (!data) return;
        for (const [key, value] of Object.entries(data)) {
            if (this.hasOwnProperty(key)) {
                this[key] = value;
            }
        }
    }
    update_cart() {
        let cart = { prix: 0, nb_articles: 0 };
        if (this.selected && this.propose) {
            cart.prix = this.prix;
            cart.nb_articles = 1;
        }
        this.cart = cart;
        return cart;
    }
    set_propose(propose) {
        this.propose = propose;
    }
    set_selected(selected) {
        this.selected = selected;
    }
    set_prix(prix) {
        this.prix = prix;
    }
}